import { useTheme } from '@/app/providers/useTheme';
import { useT } from '@/shared/i18n';
import { Icon } from '@/shared/ui/icon';
import type { ReactNode } from 'react';

export function AppThemeToggle(): ReactNode {
  const { theme, toggleTheme } = useTheme();
  const { t } = useT();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      aria-label={
        isDark ? t('theme.toggle.to-light.label') : t('theme.toggle.to-dark.label')
      }
      onClick={toggleTheme}
      className="inline-flex h-10 w-10 items-center justify-center rounded-md text-[var(--text-primary)] transition-colors hover:bg-[var(--surface-container)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary-fixed/60"
    >
      {isDark ? <Icon name="sun" size={18} /> : <Icon name="moon" size={18} />}
    </button>
  );
}
